import type { ReactFlowInstance } from 'reactflow';

interface Coords {
  x: number;
  y: number;
}
interface CenterLayoutProps {
  coords: Coords;
}
interface CenterLayoutParams {
  zoom: number;
  duration: number;
}
export const centerLayout =
  (reactFlowInstance: ReactFlowInstance) =>
  ({ coords }: CenterLayoutProps, params: CenterLayoutParams = { duration: 100, zoom: 1 }) => {
    reactFlowInstance.setCenter(coords.x, coords.y, params);
  }
